import { Link } from '@/domains/core/routing/components/Link';
import { Gtm } from '@/domains/core/tracking/utils/Gtm';
import { GTM_CLICK_ON_FOOTER_LINK } from '@/domains/retention/Footer/tracking/gtmEvents';
import { LinkListItem } from '@/retention/Footer/components/LinkList/LinkListItem';

import { LinkList } from '../../components/LinkList/LinkList';

interface NavigationLink {
  label: string;
  link: string;
  dataTestId: string;
}

interface NavigationProps {
  links: NavigationLink[];
}

export function NavigationLinks({ links }: NavigationProps) {
  return (
    <LinkList>
      {links.map(({ label, link, dataTestId, ...rest }, index) => (
        <LinkListItem
          className="py-xs"
          anchorTag={Link}
          color="dark"
          href={link}
          data-testid={dataTestId}
          key={label}
          onClick={() =>
            Gtm.push(
              GTM_CLICK_ON_FOOTER_LINK({
                text: label,
                context: 'Info and contact',
                position: index + 1,
                url: link,
              }),
            )
          }
          {...rest}
        >
          {label}
        </LinkListItem>
      ))}
    </LinkList>
  );
}
